import {Link} from '@github-ui/react-core/link'
import {getPrimaryKeybinding, GlobalCommands} from '@github-ui/ui-commands'
import {MarkGithubIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {useRef} from 'react'

import {useGlobalNavAnalytics} from '../../utils/Analytics'
import styles from './styles.module.css'

export interface HeaderLogoProps {
  href?: string
  'aria-label'?: string
}

export function HeaderLogo({href, ...props}: HeaderLogoProps) {
  const {sendItemClick} = useGlobalNavAnalytics()

  const ref = useRef<HTMLAnchorElement>(null)

  return (
    <>
      <IconButton
        as={Link}
        to={href ?? '/'}
        ref={ref}
        variant="invisible"
        className={styles.appHeaderHome}
        icon={() => <MarkGithubIcon size="medium" />}
        keybindingHint={getPrimaryKeybinding('global-navigation:go-to-dashboard')}
        aria-label="Dashboard"
        onClick={() => {
          sendItemClick('HEADER_LOGO')
        }}
        {...props}
      />
      <GlobalCommands commands={{'global-navigation:go-to-dashboard': () => ref.current?.click()}} />
    </>
  )
}
